const players = {};
let ready = false;

export const isYouTubeApiMounted = () => {
  return typeof window.YT === 'object' && window.YT.Player;
};

export const isYouTubeApiReady = () => {
  return ready;
};

const getPlayer = (iframeId, events) => {
  return new window.YT.Player(iframeId, {
    iframeId,
    events,
  });
};

window.onYouTubeIframeAPIReady = () => {
  ready = true;
  let videoId;

  if(!Object.keys(players).length) return;
  for(videoId in players) {
    if(players.hasOwnProperty(videoId)) {
      const playerOpts = players[videoId];
      playerOpts.onApiReady(getPlayer(playerOpts.id, playerOpts.events));
      delete players[videoId];
    }
  }
};

export const initPlayer = (videoId, options) => {
  if (isYouTubeApiMounted() && isYouTubeApiReady()) {
    options.onApiReady(getPlayer(options.id, options.events));
  } else if (isYouTubeApiMounted() && !isYouTubeApiReady()) {
    players[videoId] = options;
    window.onYouTubeIframeAPIReady();
  }
  players[videoId] = options;
};

export default {
  initPlayer,
  isYouTubeApiReady,
  isYouTubeApiMounted,
};



/** WEBPACK FOOTER **
 ** ./modules/youtube/index.js
 **/